import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';

const EngagementTrendChart = ({ data }) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-md shadow-lg p-3">
          <p className="font-heading font-semibold text-sm text-foreground mb-2">{label}</p>
          {payload?.map((entry, index) => (
            <div key={index} className="flex items-center justify-between gap-4 mb-1">
              <div className="flex items-center gap-2">
                <div 
                  className="w-3 h-3 rounded-full" 
                  style={{ backgroundColor: entry?.color }}
                />
                <span className="caption text-xs text-muted-foreground">{entry?.name}</span>
              </div>
              <span className="data-text text-xs font-medium text-foreground">
                {entry?.value}
              </span>
            </div>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
        <div>
          <h3 className="font-heading font-semibold text-base md:text-lg text-foreground mb-1">
            Widget Engagement Trends
          </h3>
          <p className="caption text-xs md:text-sm text-muted-foreground">
            Widget views and interactions over the last 14 days
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="TrendingUp" size={16} color="var(--color-success)" />
          <span className="caption text-xs text-success">+18.2% vs previous period</span>
        </div>
      </div>

      <div className="w-full h-64 md:h-80 lg:h-96" aria-label="Widget Engagement Trends Chart">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
            <XAxis 
              dataKey="date" 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px', fontFamily: 'var(--font-caption)' }}
            />
            <YAxis 
              stroke="var(--color-muted-foreground)"
              style={{ fontSize: '12px', fontFamily: 'var(--font-data)' }}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              wrapperStyle={{ fontSize: '12px', fontFamily: 'var(--font-caption)' }}
            />
            <Line 
              type="monotone" 
              dataKey="widgetViews" 
              stroke="var(--color-primary)" 
              strokeWidth={3}
              name="Widget Views"
              dot={{ fill: 'var(--color-primary)', r: 4 }}
              activeDot={{ r: 6 }}
            />
            <Line 
              type="monotone" 
              dataKey="interactions" 
              stroke="var(--color-accent)" 
              strokeWidth={2}
              name="Interactions"
              dot={{ fill: 'var(--color-accent)', r: 3 }}
              activeDot={{ r: 5 }}
            />
            <Line 
              type="monotone" 
              dataKey="engagement" 
              stroke="var(--color-success)" 
              strokeWidth={2}
              name="Total Engagement"
              dot={{ fill: 'var(--color-success)', r: 3 }}
              activeDot={{ r: 5 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default EngagementTrendChart;